import { useEffect, useMemo, useState } from 'react';
import { FILTER_TYPES } from '../../constants';

const getWasFilterChanged = (initialSelectedArr, newSelectedArr) => {
  if (initialSelectedArr.length !== newSelectedArr.length) {
    return true;
  }

  return newSelectedArr.some((value) => !initialSelectedArr.includes(value));
};

export const useLocalSearchFilters = (
  categoriesFilterSelectedFilterItems,
  providersFilterSelectedFilterItems
) => {
  const [categoriesFilter, setCategoriesFilter] = useState(
    categoriesFilterSelectedFilterItems || []
  );
  const [providersFilter, setProvidersFilter] = useState(
    providersFilterSelectedFilterItems || []
  );

  const setFilterItems = (prevFilterItems, filterItem) => {
    if (prevFilterItems.includes(filterItem)) {
      return prevFilterItems.filter(
        (prevFilterItem) => prevFilterItem !== filterItem
      );
    }
    return [...prevFilterItems, filterItem];
  };

  const onFilterItemClick = (filterItem, filterType) => {
    if (filterType === FILTER_TYPES.PROVIDERS) {
      setProvidersFilter((prevFilterItems) =>
        setFilterItems(prevFilterItems, filterItem)
      );
    } else {
      setCategoriesFilter((prevFilterItems) =>
        setFilterItems(prevFilterItems, filterItem)
      );
    }
  };

  const onReset = () => {
    setCategoriesFilter(categoriesFilterSelectedFilterItems || []);
    setProvidersFilter(providersFilterSelectedFilterItems || []);
  };

  useEffect(() => {
    setCategoriesFilter(categoriesFilterSelectedFilterItems || []);
    setProvidersFilter(providersFilterSelectedFilterItems || []);
  }, [categoriesFilterSelectedFilterItems, providersFilterSelectedFilterItems]);

  const wasFilterChanged = useMemo(() => {
    return (
      getWasFilterChanged(
        categoriesFilterSelectedFilterItems,
        categoriesFilter
      ) ||
      getWasFilterChanged(providersFilterSelectedFilterItems, providersFilter)
    );
  }, [
    categoriesFilterSelectedFilterItems,
    categoriesFilter,
    providersFilterSelectedFilterItems,
    providersFilter
  ]);

  return {
    categoriesFilter,
    providersFilter,
    onFilterItemClick,
    onReset,
    wasFilterChanged
  };
};
